import loading from '../assets/img/var/gif-splash.gif';
import { LoadImg } from "../styles/Template";

const Loading = () =>
<LoadImg>
  <img src={loading} alt="Loading..." />
</LoadImg>

export default Loading;